import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { CreateCurriculumSection } from '../create-curriculum-section';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import type { CreateCurriculumSchema } from '@eliadmin/core/src/pages/(jobportal)/create-curriculum/page';
import { useFormContext } from 'react-hook-form';
import { useResponsiveDialogStore } from '@eliadmin/core/src/components/ui/responsive-dialog';
import type { AddLanguageSchemaType } from '@eliadmin/core/src/components/jobportal/jobportal-create-curriculum/jobportal-add-language/jobportal-add-language-dialog';
import { JobportalAddLanguageDialog } from '@eliadmin/core/src/components/jobportal/jobportal-create-curriculum/jobportal-add-language/jobportal-add-language-dialog';
import { JobportalLanguageCard } from '@eliadmin/core/src/components/jobportal/jobportal-create-curriculum/jobportal-add-language/jobportal-language-card';
import { JobportalAddLanguageButton } from '@eliadmin/core/src/components/jobportal/jobportal-create-curriculum/jobportal-add-language/jobportal-add-language-button';

export const CreateCurriculumStep6 = () => {
  const { t } = useTranslations();

  const form = useFormContext<CreateCurriculumSchema>();

  const openDialog = useResponsiveDialogStore(s => s.open);

  const languages = form.watch('languages');

  const handleLanguageEdit = (language: AddLanguageSchemaType) => {
    if (language.id === undefined) return;

    const newLanguages = languages?.map((e: AddLanguageSchemaType) => {
      if (e.id === language.id) {
        return language;
      }
      return e;
    });
    form.setValue('languages', newLanguages as any);
  };

  const handleLanguageEditClick = (language: AddLanguageSchemaType) => {
    openDialog({
      id: JobportalAddLanguageDialog.id,
      content: (
        <JobportalAddLanguageDialog
          onEdit={handleLanguageEdit}
          dataToEdit={language}
          addedLanguages={[]}
          // addedLanguages={form
          //   .getValues('languages?')
          //   .filter((e: AddLanguageSchemaType) => e.id !== language.id)}
        />
      ),
    });
  };

  const handleLanguageDelete = (language: AddLanguageSchemaType) => {
    const newLanguages = languages?.filter((e: AddLanguageSchemaType) => e.id !== language.id);
    form.setValue('languages', newLanguages || []);
  };

  const handleLanguageDeleteClick = (language: AddLanguageSchemaType) => {
    handleLanguageDelete(language);
  };

  return (
    <div className={cn('create-curriculum-step-wrapper flex w-full flex-col gap-4')}>
      <CreateCurriculumSection title={t('text866')}>
        <p className="text-[#63626F]">{t('text1024')}</p>
        <div className={cn('flex flex-col gap-6', 'ea-jobportal-add-language__content')}>
          <div className={cn('flex flex-col gap-2', 'ea-jobportal-add-language__cards-wrapper')}>
            {languages?.length === 0 && (
              <p className={cn('p-6 text-muted-foreground', 'text-sm')}>{t('text1025')}</p>
            )}
            {languages?.map((language, index) => (
              <JobportalLanguageCard
                key={index}
                language={language}
                onLanguageEditClick={() => handleLanguageEditClick(language)}
                onLanguageDeleteClick={handleLanguageDeleteClick}
              />
            ))}
          </div>
          <JobportalAddLanguageButton />
        </div>
      </CreateCurriculumSection>
    </div>
  );
};
